import { render, staticRenderFns } from "./BehaviourDetection.vue?vue&type=template&id=5e54cd94"
import script from "./BehaviourDetection.vue?vue&type=script&lang=js"
export * from "./BehaviourDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports